import axios from 'axios';
import { getConfig, DEV_MODE, DISABLE_AUTH } from '../auth/authConfig';

const API_BASE_URL = getConfig('REACT_APP_API_URL', 'https://localhost:8000');

// Store auth instance reference for logout
let authInstance = null;

export const setAuthInstance = (auth) => {
    authInstance = auth;
};

export const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Function to set the auth token
export const setAuthToken = (token) => {
    if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete api.defaults.headers.common['Authorization'];
    }
};

// Request interceptor: подставляем токен перед каждым запросом (избегаем гонки: первый запрос до useEffect)
api.interceptors.request.use(
    (config) => {
        const token = authInstance?.user?.access_token;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        // Skip auth handling in dev mode
        if (DEV_MODE || DISABLE_AUTH) {
            return Promise.reject(error);
        }

        if (error.response) {
            // Server responded with error status
            console.error('API Error:', error.response.data);

            // Handle 401 Unauthorized - token expired or invalid
            if (error.response.status === 401) {
                console.error('Unauthorized - Token expired or invalid');
                console.error('Error details:', error.response.data);

                // Clear invalid token and redirect to login immediately
                if (authInstance) {
                    console.log('Redirecting to login due to 401 error');
                    await authInstance.removeUser();
                    authInstance.signinRedirect();
                }
            }

            // Handle 403 Forbidden - insufficient permissions
            if (error.response.status === 403) {
                console.error('Forbidden - Insufficient permissions');
                console.error('Error details:', error.response.data);

                // Clear session and redirect to login
                if (authInstance) {
                    console.log('Redirecting to login due to 403 error');
                    await authInstance.removeUser();
                    authInstance.signinRedirect();
                }
            }
        } else if (error.request) {
            // Request was made but no response received
            console.error('Network Error:', error.request);
        } else {
            // Something else happened
            console.error('Error:', error.message);
        }
        return Promise.reject(error);
    }
);

// API functions
export const loadTemplates = async () => {
    const response = await api.get('/templates');
    return response.data;
};